module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "char"
    }
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Main Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Jahangir’s family")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Akbar, Jahangir’s father and the third Moghul emperor")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Humayun, Jahangir’s grandfather and the second Moghul emperor")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hamida, Jahangir’s grandmother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kamran, Jahangir’s great-uncle")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Askari, Jahangir’s great-uncle")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hindal, Jahangir’s great-uncle")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Murad, Jahangir’s brother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Daniyal, Jahangir’s brother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Khusrau, Jahangir’s eldest son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Parvez, Jahangir’s second son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Khurram (later the Emperor Shah Jahan), Jahangir’s third son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Shahriyar, Jahangir’s youngest son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Man Bai, Jahangir’s wife and mother of Khusrau")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jodh Bai, Jahangir’s wife and mother of Khurram")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sahib Jamal, Jahangir’s wife and mother of Parvez")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mehrunissa (also known as Nur Mahal and Nur Jahan), Jahangir’s last wife")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Mehrunissa’s family")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ladli, Mehrunissa’s daughter by Sher Afghan")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ghiyas Beg, Imperial Treasurer and Mehrunissa’s father")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Asmat, mother of Mehrunissa and her brothers")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Asaf Khan, commander of the Agra garrison and Mehrunissa’s elder brother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mir Khan, Mehrunissa’s younger brother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Arjumand Banu, Mehrunissa’s niece, Asaf Khan’s daughter and wife of Khurram (Shah Jahan)")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sher Afghan, commander of the garrison at Gaur in Bengal, Mehrunissa’s first husband")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Jahangir’s commanders, governors and courtiers")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Suleiman Beg, Jahangir’s milk-brother")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Ali Khan, Governor of Mandu")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Iqbal Beg, a senior commander in the Deccan")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mahabat Khan, a Persian and one of Jahangir’s leading generals")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Majid Khan, Jahangir’s vizier and chronicler")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Yar Muhammad, Governor of Gwalior")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dara Shukoh, Khurram’s (Shah Jahan’s) eldest son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Shah Shujah, Khurram’s (Shah Jahan’s) second son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Aurangzeb, Khurram’s (Shah Jahan’s) third son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Murad Bakhsh, Khurram’s (Shah Jahan’s) youngest son")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Jahanara, Khurram’s (Shah Jahan’s) elder daughter")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Roshanara, Khurram’s (Shah Jahan’s) younger daughter")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("In the imperial")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("haram")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Mala, "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("khawajasara,")]), _vm._v(" superintendent, of the imperial "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("haram")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fatima Begam, a widow of the Emperor Akbar")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nadya, Fatima Begam’s maid")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Salla, Mehrunissa’s Armenian lady-in-waiting")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Khurram’s circle")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Azam Bahksh, one of Akbar’s aged former commanders")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Kamran Iqbal, one of Khurram’s commanders")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Walid Beg, one of Khurram’s gunnery commanders")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Others")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Aziz Koka, adherent of Khusrau")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Hassan Jamal, adherent of Khusrau")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Malik Ambar, former Abyssinian slave and now commander of the armies of the Deccan sultanates against the Moghuls")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Shaikh Salim Chishti, a Sufi mystic, and his son, also a Sufi.")]), _vm._v(" "), _c('p', {
    staticClass: "bib2"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Foreigners in the Moghul empire")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Bartholomew Hawkins, English soldier and adventurer")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Father Ronaldo, a Portuguese priest")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Sir Thomas Roe, English ambassador to the Moghul court")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Nicholas Ballantyne, squire to Sir Thomas Roe")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09078b18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/char.vue
// module id = 72
// module chunks = 0